export enum BreadCrumbType {
  TEXT = 'text',
  LINK = 'link',
}

export enum BreadCrumbIcon {
  VIA_BTC = 'via-btc',
  HOSTING = 'hosting',
}

export interface IBreadCrumb {
  title: string;
  icon?: string;
  link?: string | null;
  type: BreadCrumbType;
}
